module.exports = __webpack_public_path__ + "img/tractor-blue.c26ae358.svg";